package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings
import er.prateek.crossly.data.model.SavedPuzzleSession
import kotlinx.serialization.json.Json

private val sessionJson = Json { ignoreUnknownKeys = true }
private const val KEY_SAVED_SESSION = "saved_puzzle_session"

class SettingsSavedSessionStore(
    private val settings: Settings,
) : SavedSessionStore {
    override fun load(): SavedPuzzleSession? {
        val raw = settings.getStringOrNull(KEY_SAVED_SESSION) ?: return null
        return runCatching { sessionJson.decodeFromString(SavedPuzzleSession.serializer(), raw) }
            .getOrNull()
    }

    override fun save(session: SavedPuzzleSession?) {
        if (session == null) {
            settings.remove(KEY_SAVED_SESSION)
        } else {
            settings.putString(KEY_SAVED_SESSION, sessionJson.encodeToString(SavedPuzzleSession.serializer(), session))
        }
    }
}
